<div class="edit-scheduler-page-container">
  <mwo-scheduler-modifier-header (onBreadcrumbClicked)="handleCancel()"></mwo-scheduler-modifier-header>
  <div class="edit-day-schedule-manager-container">
    <div *ngIf="!isCanceling && !(scheduleUpdateLoading$ | async)" class="">
      <mwo-edit-day-schedule (onEdit)="handleEdit($event)" [list]="slots"></mwo-edit-day-schedule>
    </div>
    <div *ngIf="isCanceling || (scheduleUpdateLoading$ | async)" class="edit-day-schedule-manager-spinner">
      <mat-spinner diameter="100" strokeWidth="10"></mat-spinner>
    </div>
    <div class="edit-day-schedule-manager-plus">
      <mwo-main-button (onClick)="handleCancel()" [disabled]="isCanceling || (scheduleUpdateLoading$ | async)"
                       text="{{'planning.cancel' | translate}}"></mwo-main-button>
      <mwo-button (click)="handleAdd()" [disable]="isCanceling || (scheduleUpdateLoading$ | async)"
                  [icon]="'add'"></mwo-button>
      <mwo-main-button (onClick)="handleValidate()"
                       [disabled]="isCanceling || !canValidate() || (scheduleUpdateLoading$ | async)"
                       text="{{'planning.validate' | translate}}"></mwo-main-button>
    </div>
  </div>
</div>

